<template>
  <div>
    <v-container>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel v-for="(item, i) in services" :key="i">
          <v-expansion-panel-header>{{ item.label }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                class="col-4"
                v-for="(exchange, j) in exchangeList.filter(row => {
                  return row.serviceId === item.id
                })"
                :key="j"
              >
                <v-card class="mx-auto" max-width="344" outlined>
                  <v-list-item three-line class="red lighten-5">
                    <v-list-item-content>
                      <div class="text-overline mb-4">
                        {{ exchange.label }}
                      </div>
                      <v-list-item-subtitle>{{
                        exchange.desc
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-card-actions>
                    <a
                      :href="
                        'http://localhost:8081/Tool/CollectQRCode?mode=shortcut&shortcutExchangeId=' +
                          exchange.exchangeId +
                          '&shortcutAmount=' +
                          exchange.amount
                      "
                      >เลือก</a
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>
<script>
export default {
  components: {},
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      panel: [0, 1, 2],
      services: [
        { id: 1, label: 'ประกัน' },
        { id: 2, label: 'ออกรถใหม่' },
        { id: 3, label: 'Services' }
      ],
      exchangeList: [
        {
          serviceId: 1,
          label: 'ประกัน 300 เหรียญ',
          exchangeId: 243,
          amount: 300,
          desc: 'ซื้อประกันภัย ค่าเบี้ยเริ่ม 10,000 - 15,000 บาท'
        },
        {
          serviceId: 1,
          label: 'ประกัน 500 เหรียญ',
          exchangeId: 218,
          amount: 500,
          desc: 'ซื้อประกันภัย ค่าเบี้ยประกัน 15,001 บาทขึ้นไป'
        },
        {
          serviceId: 2,
          label: 'ออกรถใหม่รับไปเลย 1,000 เหรียญ',
          exchangeId: 165,
          amount: 1000,
          desc: 'ออกรถใหม่รับไปเลย 1,000 เหรียญ'
        },
        {
          serviceId: 3,
          label: 'PM 100 เหรียญ',
          exchangeId: 251,
          amount: 100,
          desc: 'ทุกครั้งที่เข้ารับบริการ'
        },
        {
          serviceId: 3,
          label: 'GR 100 เหรียญ',
          exchangeId: 252,
          amount: 100,
          desc: 'ค่าใช้จ่ายมากกว่า 2,000 บาทขึ้นไป'
        },
        {
          serviceId: 3,
          label: 'BP 100 เหรียญ',
          exchangeId: 253,
          amount: 100,
          desc: 'ค่าใช้จ่ายมากกว่า 5,000 บาทขึ้นไป'
        }
      ]
    }
  },
  async mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/Tool/VGroupShortcut.vue